﻿(function() {
    "use strict";

    angular.module("app").controller("MaintenancesController", MaintenancesController);

    MaintenancesController.$inject = ["constants"];

    function MaintenancesController(constants) {
        var vm = this
        vm.constants = constants;
        vm.$onInit = onInit;

        function onInit() {
            vm.deleted = location.hash.indexOf('/deleted') > -1
        }
    }
})();
